<template>
	<DebugModeComponent v-if="debugData != undefined" :debugData="debugData" :labelPreview="labelPreview" />
	<template v-for="(section, index) in sectionData" :key="index" >
		<ContactPersonComponent :contactPersonData="sectionData[index]" :mainSettings="mainSettings" :index="index" v-if="section.type == 'contactPerson' && sectionData[index].config != ''" isMultiblock="false" />
		<EnergyDataComponent :energyData="sectionData[index]" :index="index" v-else-if="section.type == 'energyData' && sectionData[index].config != ''" isMultiblock="false" />
		<FactsComponent :factsData="sectionData[index]" :index="index" v-else-if="section.type == 'data' && sectionData[index].config != ''" isMultiblock="false" />
		<FeedbackComponent :feedbackData="sectionData[index]" :index="index" v-else-if="section.type == 'contact' && sectionData[index].config != ''" isMultiblock="false"/>
		<FileComponent :fileData="sectionData[index]" :index="index" v-else-if="section.type == 'files' && sectionData[index].config != ''" isMultiblock="false" />
		<FreetextComponent :freetextData="sectionData[index]" :index="index" v-else-if="section.type == 'freeTexts' && sectionData[index].config != ''" isMultiblock="false" />
		<GalleryComponent :pictureData="sectionData[index]" :index="index" :pictureKey="index" v-else-if="section.type == 'pictures' && sectionData[index].config != '' && sectionData[index].config.pictures != ''" isMultiblock="false" />
		<LayoutComponent :layoutData="sectionData[index]" :index="index" v-else-if="section.type == 'layout' && sectionData[index].config != ''" isMultiblock="false" />
		<LocationComponent :locationData="sectionData[index]" :index="index" v-else-if="section.type == 'maps' && sectionData[index].config != ''" isMultiblock="false" />
		<MultiBlockComponent :multiData="sectionData[index]" :index="index" :pictureKey="index" v-else-if="section.type == 'combo' && sectionData[index].config != ''" />
		<TextComponent :textData="sectionData[index]" :index="index" v-else-if="section.type == 'text' && sectionData[index].config != ''" isMultiblock="false" />
		<TitleComponent :titleData="sectionData[index]" :mainSettings="mainSettings" :index="index" v-else-if="section.type == 'title' && sectionData[index].config != ''" isMultiblock="false" />
		<UnitListComponent :unitListData="sectionData[index]" :index="index" v-else-if="section.type == 'unitList' && sectionData[index].config != ''" isMultiblock="false" />
		<VideoComponent :videoData="sectionData[index]" :index="index" v-else-if="section.type == 'video' && sectionData[index].config != ''" isMultiblock="false" />
		<VirtualTourComponent :virtualTourData="sectionData[index]" :index="index" v-else-if="section.type == 'virtualTour' && sectionData[index].config != ''" isMultiblock="false" />
		<!-- <PlaceholderComponent :placeholderData="sectionData[index].config" v-else isMultiblock="false" /> -->
	</template>
	<FooterComponent :footerData="mainSettings" v-if="isLoaded == true" id="container-footer" class="container-footer" />
	<NavigationComponent :navigationData="sectionData" :mainSettings="mainSettings" v-if="isLoaded == true" id="container-navigation" class="container-navigation fixed-bottom" />
</template>

<script>

import ContactPersonComponent from "./ContactPersonComponent.vue";
import DebugModeComponent from "../DebugModeComponent.vue";
import EnergyDataComponent from "./EnergyDataComponent.vue";
import FactsComponent from "./FactsComponent.vue";
import FeedbackComponent from "../FeedbackComponent.vue";
import FileComponent from "./FileComponent.vue";
import FreetextComponent from "./FreetextComponent.vue";
import GalleryComponent from "./GalleryComponent.vue";
import LayoutComponent from "./LayoutComponent.vue";
import LocationComponent from "./LocationComponent.vue";
import MultiBlockComponent from "./MultiBlockComponent.vue";
// import PlaceholderComponent from "./PlaceholderComponent.vue";
import TitleComponent from "./TitleComponent.vue";
import TextComponent from "./TextComponent.vue";
import UnitListComponent from "./UnitListComponent.vue";
import VideoComponent from "./VideoComponent.vue";
import VirtualTourComponent from "./VirtualTourComponent.vue";
import NavigationComponent from "./NavigationComponent.vue";
import FooterComponent from "./FooterComponent.vue";

export default {
	components: {
    ContactPersonComponent,
    DebugModeComponent,
    EnergyDataComponent,
    FactsComponent,
    FeedbackComponent,
    FileComponent,
    FreetextComponent,
    GalleryComponent,
    LayoutComponent,
    LocationComponent,
    MultiBlockComponent,
    // PlaceholderComponent,
    TextComponent,
    TitleComponent,
    UnitListComponent,
    VideoComponent,
    VirtualTourComponent,
    NavigationComponent,
    FooterComponent
	},

	props: {
		mainSettings: {
			type: Object
		},
		sectionData: {
			type: Object
		},
		debugData: {
			type: Object
		},
		isMultiblock: {
			type: String
		},
		labelPreview: {
			type: Array
		}
	},

	data() {
		return {
			isLoaded: false
		}
	},

	methods: {
		loaded() {
			this.isLoaded = true;
		},
	},

	mounted() {
		this.loaded();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/sectionComponent.scss";
</style>